<template>

    <el-alert :title="$t('pages.ecommerce.productManagement.product.save.informationBoxes.imageGallery')" type="warning" :closable="false" />

    <div class="d-flex flex-wrap flex-stack py-5">
        <h2 class="fs-2 fw-bold my-2">{{ $t('pages.ecommerce.productManagement.product.save.tabs.imageGalleries') }}</h2>

        <div class="d-flex flex-wrap my-1" v-if="product.image_galleries.length > 0">
            <a class="newMediaBtn btn btn-sm btn-primary align-self-center" v-on:click="newImage">
                <span class="svg-icon svg-icon-3">
                    <inline-svg src="/media/icons/duotune/arrows/arr009.svg"/>
                </span>
                {{ $t('btn.new') }}
            </a>
        </div>
    </div>

    <div class="row g-6 g-xl-9" v-if="product.image_galleries.length > 0">
        <div class="col-sm-6 col-md-4 col-xxl-3" v-for="(file, fileIndex) in product.image_galleries" :key="fileIndex">
            <div class="card h-100">
                <div class="card-body d-flex justify-content-center text-center flex-column p-8">

                    <div class="position-absolute top-0 end-0 d-flex align-items-center flex-column gap-3 mt-3 me-3 z-index-1">
                        <a v-on:click="updateImage(file.id)" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                                <span class="svg-icon svg-icon-3">
                                    <inline-svg src="/media/icons/duotune/art/art005.svg"/>
                                </span>
                        </a>
                        <el-popconfirm :title="$t('messages.sureDelete')" :confirm-button-text="$t('btn.yes')" :cancel-button-text="$t('btn.no')" @confirm="deleteImage(file.id)">
                            <template #reference>
                                <a class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">
                                    <span class="svg-icon svg-icon-3">
                                        <inline-svg src="/media/icons/duotune/general/gen027.svg"/>
                                    </span>
                                </a>
                            </template>
                        </el-popconfirm>
                    </div>
                    <div class="symbol mb-6">
                        <img class="h-100 w-auto max-w-150px object-fit-contain" :src="file.image.public_url" alt=""/>
                    </div>
                    <div class="fs-5 fw-bolder mb-2">{{ file.image.name }}</div>
                    <div class="fs-7 fw-bold text-gray-700 mt-auto mb-2">({{ file.image.size_text }})</div>
                </div>
            </div>
        </div>
    </div>

    <div class="d-flex flex-column align-items-center justify-content-center" v-else>
        <inline-svg src="/media/icons/duotune/general/gen006.svg" style="height: 64px; width: 64px;"/>
        <p class="text-muted mt-3">Ürün Galerisinde Resim Bulunmamaktadır.</p>
        <a class="newMediaBtn btn btn-sm btn-primary align-self-center" v-on:click="newImage">
            <span class="svg-icon svg-icon-3">
                <inline-svg src="/media/icons/duotune/arrows/arr009.svg"/>
            </span>
            {{ $t('btn.new') }}
        </a>
    </div>

    <div class="modal fade" id="kt_modal_image_gallery" ref="imageGalleryModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered mw-650px">
            <div class="modal-content">
                <div class="modal-header" id="kt_modal_change_password_header">
                    <h2 class="fw-bolder">{{ form.title }}</h2>
                    <div id="kt_modal_change_password_close" data-bs-dismiss="modal" class="btn btn-icon btn-sm btn-active-icon-primary">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="/media/icons/duotune/arrows/arr061.svg"/>
                        </span>
                    </div>
                </div>
                <el-form @submit.prevent="onSubmit()" :model="form.data" ref="mediaForm">
                    <div class="modal-body py-10 px-lg-17">
                        <div class="scroll-y me-n7 pe-7" id="kt_modal_change_password_scroll" data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto" data-kt-scroll-dependencies="#kt_modal_add_customer_header" data-kt-scroll-wrappers="#kt_modal_add_customer_scroll" data-kt-scroll-offset="300px">
                            <div class="d-flex justify-content-between">
                                <div class="fv-row mb-7">
                                    <label class="fs-6 fw-bold mb-2">{{ $t('pages.ecommerce.productManagement.product.save.cols.image') }}</label>
                                    <el-form-item prop="image_id">
                                        <el-upload :accept="$root.acceptFileSupported('image', 'image/')" v-bind:class="{'disabled-upload': form.fileList.length > 0}" :on-change="handleChangeImage" :on-remove="handleChangeImage"
                                                   list-type="picture-card" :file-list="form.fileList" limit="1" :on-preview="handlePictureCardPreview" :auto-upload="false">
                                            <i class="bi bi-plus"/>
                                        </el-upload>
                                        <el-dialog v-model="form.dialogVisible" width="30%">
                                            <img style="width: 100%" :src="form.dialogImageUrl" alt=""/>
                                        </el-dialog>
                                    </el-form-item>
                                </div>
                                <div>
                                    <div class="fv-row">
                                        <label class="fs-6 fw-bold mb-2">{{ $t('pages.ecommerce.productManagement.product.save.cols.sort') }}</label>
                                        <el-form-item prop="sort">
                                            <el-input-number v-model="form.data.sort" :min="1"/>
                                        </el-form-item>
                                    </div>
                                    <div class="fv-row">
                                        <label class="fs-6 fw-bold mb-2">{{ $t('pages.ecommerce.productManagement.product.save.cols.status') }}</label>
                                        <el-form-item prop="active">
                                            <el-radio-group v-model="form.data.active">
                                                <el-radio-button :label="true">{{ $t("common.active") }}</el-radio-button>
                                                <el-radio-button :label="false">{{ $t("common.passive") }}</el-radio-button>
                                            </el-radio-group>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer flex-center">
                        <button :data-kt-indicator="form.loading ? 'on' : null" class="btn btn-lg btn-primary" type="submit" :disabled="form.loading">
                            <span v-if="!form.loading" class="indicator-label">{{ $t("btn.save") }}</span>
                            <span v-if="form.loading" class="indicator-progress">
                                {{ $t("messages.wait") }}
                                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>

</template>

<script>

export default {
    props: [
        'productID',
        'product',
    ],
    name: "PackageItem",
    inject: ['loadCustomizePage'],
    components: {},
    data() {
        return {
            form: {
                loading: false,
                updateStatus: false,
                fileList: [],
                uploadList: [],
                dialogImageUrl: null,
                dialogVisible: false,
                data: {
                    product_id: null,
                    language_id: 1,
                    is_poster: false,
                    image_id: null,
                    sort: 1,
                    active: true
                },
            },
        }
    },
    computed: {},
    mounted() {

    },
    methods: {
        newImage() {
            this.form.updateStatus = false;
            this.form.data = {
                product_id: this.product.id,
                language_id: 1,
                is_poster: false,
                image_id: null,
                sort: 1,
                active: true
            };
            this.form.uploadList = [];
            this.form.fileList = [];
            this.form.title = this.$t("pages.media.newMedia");
            this.showModal(this.$refs.imageGalleryModal);
        },

        updateImage(id) {
            this.form.loading = true;
            this.form.updateStatus = true;
            this.axios.get(this.endpoints["ecommerce_product_image_gallery"] + '/' + id).then(response => {
                this.form.data = {
                    id: id,
                    product_id: this.product.id,
                    language_id: response.data.data.language_id,
                    is_poster: response.data.data.is_poster,
                    image_id: response.data.data.image_id,
                    sort: response.data.data.sort,
                    active: response.data.data.active
                };
                this.form.dialogImageUrl = response.data.data.image.public_url;
                this.form.fileList = [{
                    'name': response.data.data.image.name,
                    'image_id': response.data.data.image.image_id,
                    'url': response.data.data.image.public_url
                }];
                this.form.dialogVisible = false;
                this.form.title = response.data.data.image.name;
                this.form.loading = false;
                this.showModal(this.$refs.imageGalleryModal);
            })
        },

        onSubmit() {
            if (this.form.updateStatus && this.form.data.id) {
                if (!(this.form.uploadList.length > 0)) {
                    this.axios.put(this.endpoints["ecommerce_product_image_gallery"] + '/' + this.form.data.id, this.form.data).then(response => {
                        this.onResponse(response.data, () => {
                            this.$emit('loadProduct', this.productID);
                            this.hideModal(this.$refs.imageGalleryModal);
                            this.form.updateStatus = false;
                            this.form.data = {
                                product_id: this.product.id,
                                language_id: 1,
                                is_poster: false,
                                image_id: null,
                                sort: 1,
                                active: true
                            };
                            this.form.uploadList = [];
                            this.form.fileList = [];
                        }, () => {
                            this.form.loading = false;
                        });
                    }).catch(error => {
                        this.onResponseFailure(error.response.data, () => {
                            this.form.loading = false;
                        });
                    });
                } else {
                    this.form.loading = true;
                    const formData = new FormData();
                    this.form.uploadList.forEach(file => {
                        formData.append("file[]", file.raw);
                    });

                    this.axios.post(this.endpoints["file"], formData).then(responseFile => {
                        this.form.data.image_id = responseFile.data.data[0].id;
                        this.axios.put(this.endpoints["ecommerce_product_image_gallery"] + '/' + this.form.data.id, this.form.data).then(response => {
                            this.onResponse(response.data, () => {
                                this.$emit('loadProduct', this.productID);
                                this.hideModal(this.$refs.imageGalleryModal);
                                this.form.updateStatus = false;
                                this.form.data = {
                                    product_id: this.product.id,
                                    language_id: 1,
                                    is_poster: false,
                                    image_id: null,
                                    sort: 1,
                                    active: true
                                };
                                this.form.uploadList = [];
                                this.form.fileList = [];
                            }, () => {
                                this.form.loading = false;
                            });
                        }).catch(error => {
                            this.onResponseFailure(error.response.data, () => {
                                this.form.loading = false;
                            });
                        });
                    }).catch(error => {
                        this.onResponseFailure(error.response.data, () => {
                            this.form.loading = false;
                        });
                    });
                }
            } else {
                if (!(this.form.uploadList.length > 0)) {
                    this.$notify({
                        type: 'warning',
                        title: this.$t("messages.warning"),
                        message: this.$t("pages.media.warnings.files"),
                    })
                    return false;
                }

                this.form.loading = true;
                const formData = new FormData();
                this.form.uploadList.forEach(file => {
                    formData.append("file[]", file.raw);
                });

                this.axios.post(this.endpoints["file"], formData).then(responseFile => {
                    this.form.data.image_id = responseFile.data.data[0].id;
                    this.axios.post(this.endpoints["ecommerce_product_image_gallery"], this.form.data).then(response => {
                        this.onResponse(response.data, () => {
                            this.$emit('loadProduct', this.productID);
                            this.hideModal(this.$refs.imageGalleryModal);
                            this.form.updateStatus = false;
                            this.form.data = {
                                product_id: this.product.id,
                                language_id: 1,
                                is_poster: false,
                                image_id: null,
                                sort: 1,
                                active: true
                            };
                            this.form.uploadList = [];
                            this.form.fileList = [];
                        }, () => {
                            this.form.loading = false;
                        });
                    }).catch(error => {
                        this.onResponseFailure(error.response.data, () => {
                            this.form.loading = false;
                        });
                    });
                }).catch(error => {
                    this.onResponseFailure(error.response.data, () => {
                        this.form.loading = false;
                    });
                });
            }
        },

        deleteImage(id) {
            this.axios.delete(this.endpoints["ecommerce_product_image_gallery"] + '/' + id).then((successDeleted) => {
                this.onResponse(successDeleted.data, () => {
                    this.$emit('loadProduct', this.productID);
                });
            }).catch(error => {
                this.onResponseFailure(error.response.data, () => {
                    this.form.loading = false;
                });
            });
        },

        handlePictureCardPreview(file) {
            this.form.dialogImageUrl = file.url
            this.form.dialogVisible = true
        },

        handleChangeImage(file, fileList) {
            this.form.fileList = fileList;
            this.form.uploadList = fileList;
        },
    }
}
</script>

<style scoped>

</style>